export default {
    isFetching: false,
    isRequesting: false,
    category: {},
    categories: []
};